import DataMapper from './DataMapper'
import PerformanceEvaluationRM from '../responsemodel/PerformanceEvaluationRM'
import PerformanceEvaluation from '../../models/PerfomanceEvaluation'

export default class PerformanceEvaluationDataMapper extends DataMapper<PerformanceEvaluationRM, PerformanceEvaluation> {
  map = (rm: PerformanceEvaluationRM) => {
    return new PerformanceEvaluation(rm.summary, rm.file)
  }
}
